import { lazy, Suspense } from 'react';
import { ImageViewerProps } from './interfaces';

// Lazy load ImageViewer to reduce initial bundle (includes Konva ~183KB gzip)
const ImageViewerComponent = lazy(() => import('./ImageViewer').then(mod => ({ default: mod.ImageViewer })));

// Fallback component while ImageViewer is loading
function ImageViewerFallback({ width = '100%', height = '500px' }: { width?: string | number; height?: string | number }) {
  return (
    <div 
      style={{ 
        width: typeof width === 'number' ? `${width}px` : width,
        height: typeof height === 'number' ? `${height}px` : height,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'rgba(0,0,0,0.05)',
        borderRadius: '4px'
      }}
    >
      <div className="text-center">
        <div className="spinner-border text-primary mb-2" role="status">
          <span className="visually-hidden">Loading image viewer...</span>
        </div>
        <div style={{ fontSize: '14px', opacity: 0.7 }}>Loading image viewer...</div>
      </div>
    </div>
  );
}

export function ImageViewerLazy(props: ImageViewerProps) {
  return (
    <Suspense fallback={<ImageViewerFallback width={props.width} height={props.height} />}>
      <ImageViewerComponent {...props} />
    </Suspense>
  );
}

export default ImageViewerLazy;
